import { ArrowLeft, Package, CheckCircle, MapPin, Star, Bell, List, TrendingUp, User } from "lucide-react";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { useCourierLanguage } from "../contexts/CourierLanguageContext";
import { useNotifications } from "../CourierApp";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CourierNotifications({
  navigateTo
}) {
  const {
    t
  } = useCourierLanguage();
  const {
    setHasUnread
  } = useNotifications();
  const [notifications, setNotifications] = useState([{
    id: 1,
    icon: Package,
    title: "Yeni çatdırılma təyin edildi",
    message: "PKG-2891 bağlaması sizə təyin edildi",
    time: "5 dəqiqə əvvəl",
    isRead: false,
    color: "#2D58AD"
  }, {
    id: 2,
    icon: CheckCircle,
    title: "Bağlama #102 çatdırıldı",
    message: "Aydin Məmmədova uğurla çatdırıldı",
    time: "32 dəqiqə əvvəl",
    isRead: false,
    color: "#10B981"
  }, {
    id: 3,
    icon: MapPin,
    title: "Marşrut trafik səbəbi ilə yeniləndi",
    message: "Nobel prospektindəki sıxlığı önləmək üçün marşrutunuz optimallaşdırıldı",
    time: "1 saat əvvəl",
    isRead: true,
    color: "#F59E0B"
  }, {
    id: 4,
    icon: Star,
    title: "Müştəri sizə 5 ulduz verdi",
    message: "Leyla Həsənova xidmətiniz üçün əla rəy buraxdı",
    time: "2 saat əvvəl",
    isRead: true,
    color: "#F59E0B"
  }, {
    id: 5,
    icon: Package,
    title: "Yeni çatdırılma təyin edildi",
    message: "PKG-2890 bağlaması sizə təyin edildi",
    time: "3 saat əvvəl",
    isRead: true,
    color: "#2D58AD"
  }, {
    id: 6,
    icon: CheckCircle,
    title: "Bağlama #98 çatdırıldı",
    message: "Rəşad Əliyevə uğurla çatdırıldı",
    time: "5 saat əvvəl",
    isRead: true,
    color: "#10B981"
  }]);
  const markAsRead = id => {
    setNotifications(notifications.map(notif => notif.id === id ? {
      ...notif,
      isRead: true
    } : notif));
  };
  const markAllAsRead = () => {
    setNotifications(notifications.map(notif => ({
      ...notif,
      isRead: true
    })));
    setHasUnread(false);
  };
  const unreadCount = notifications.filter(n => !n.isRead).length;
  useEffect(() => {
    setHasUnread(unreadCount > 0);
  }, [unreadCount, setHasUnread]);
  return /*#__PURE__*/_jsxs("div", {
    className: "min-h-screen bg---F5F6FA- pb-24",
    children: [/*#__PURE__*/_jsx("div", {
      className: "bg-gradient-to-r from---2D58AD- to---71A4F4- text-white p-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-4 mb-4",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: () => navigateTo("dashboard"),
          className: "w-10 h-10 bg-white-20 backdrop-blur-sm rounded-xl flex items-center justify-center hover-bg-white-30 transition-colors",
          children: /*#__PURE__*/_jsx(ArrowLeft, {
            className: "w-6 h-6"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex-1",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "text-2xl font-bold",
            children: t.notifications
          }), unreadCount > 0 && /*#__PURE__*/_jsxs("p", {
            className: "text-white-80 text-sm",
            children: [unreadCount, " ", t.unreadNotifications]
          })]
        }), unreadCount > 0 && /*#__PURE__*/_jsx("button", {
          onClick: markAllAsRead,
          className: "px-3 py-1-5 bg-white-20 backdrop-blur-sm rounded-lg text-sm font-medium hover-bg-white-30 transition-colors",
          children: t.markAllAsRead
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "p-4 space-y-3",
      children: notifications.map((notif, index) => {
        const IconComponent = notif.icon;
        return /*#__PURE__*/_jsx(motion.div, {
          initial: {
            opacity: 0,
            y: 20
          },
          animate: {
            opacity: 1,
            y: 0
          },
          transition: {
            delay: index * 0.05
          },
          onClick: () => !notif.isRead && markAsRead(notif.id),
          className: `bg-white rounded-2xl p-4 shadow-sm cursor-pointer transition-all ${!notif.isRead ? "border-l-4 border-neg-2D58AD-" : ""}`,
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex items-start gap-3",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0",
              style: {
                backgroundColor: `${notif.color}20`
              },
              children: /*#__PURE__*/_jsx(IconComponent, {
                className: "w-6 h-6",
                style: {
                  color: notif.color
                }
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex-1 min-w-0",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex items-start justify-between gap-2 mb-1",
                children: [/*#__PURE__*/_jsx("h3", {
                  className: `font-semibold ${!notif.isRead ? "text---000080-" : "text-neg-708094-"}`,
                  children: notif.title
                }), !notif.isRead && /*#__PURE__*/_jsx("div", {
                  className: "w-2 h-2 bg-neg-2D58AD- rounded-full flex-shrink-0 mt-1-5"
                })]
              }), /*#__PURE__*/_jsx("p", {
                className: "text-sm text-neg-708094- mb-2",
                children: notif.message
              }), /*#__PURE__*/_jsx("p", {
                className: "text-xs text-neg-708094-",
                children: notif.time
              })]
            })]
          })
        }, notif.id);
      })
    }), notifications.length === 0 && /*#__PURE__*/_jsxs("div", {
      className: "text-center py-12",
      children: [/*#__PURE__*/_jsx(Bell, {
        className: "w-16 h-16 text-neg-708094- mx-auto mb-4 opacity-50"
      }), /*#__PURE__*/_jsx("p", {
        className: "text-neg-708094-",
        children: "Bildiri\u015F yoxdur"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-around max-w-md mx-auto",
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("dashboard"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(Package, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.home
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("packages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(List, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.packages
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("performance"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(TrendingUp, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.performance
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("profile"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(User, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.profile
          })]
        })]
      })
    })]
  });
}